import React, { useEffect, useState } from "react";
//import DefaultBackground from "/assets/DefaultBackground.png";

export default function PayPage() {
  const [message, setMessage] = useState("Preparing your secure checkout...");
  const [error, setError] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("t");

    console.log("PayPage loaded.");
    console.log("Current URL:", window.location.href);
    console.log("Token:", token);

    if (!token) {
      setMessage("We couldn't open your payment link.");
      setError("Missing payment token.");
      return;
    }

    const resolverUrl =
      "https://rgs-a.azurewebsites.net/api/Resolve_Payment_Link?t=" +
      encodeURIComponent(token);

    fetch(resolverUrl, {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    })
      .then(async (res) => {
        console.log("Resolver status:", res.status);
        console.log("Resolver ok?:", res.ok);

        let data = null;

        try {
          data = await res.json();
        } catch {
          throw new Error("The payment service returned an unreadable response.");
        }

        if (!res.ok) {
          throw new Error(data?.error || "Unable to resolve this payment link.");
        }

        if (!data.success || !data.checkoutUrl) {
          throw new Error("Payment link response was missing checkout URL.");
        }

        console.log("Redirect target:", data.checkoutUrl);
        alert("Redirect target: " + data.checkoutUrl);

        setMessage("Redirect paused for debugging.");
        setError("Redirect target: " + data.checkoutUrl);

        window.location.href = data.checkoutUrl;
      })

      .catch((err) => {
        console.error("PayPage error:", err);
        setMessage("We couldn't open your payment link.");
        setError(err.message || "Please contact support.");
      });
  }, []);

  return (
    <div
      style={{
        margin: 0,
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "Arial, sans-serif",
        background: `"/assets/DefaultBackground.png" no-repeat center center fixed`,
        backgroundSize: "cover",
        position: "relative",
      }}
    >
      <div
        style={{
          position: "absolute",
          inset: 0,
          background: "rgba(0,0,0,0.35)",
        }}
      />

      <div
        style={{
          position: "relative",
          zIndex: 1,
          background: "#ffffff",
          padding: "32px 28px",
          borderRadius: "14px",
          boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
          maxWidth: "420px",
          width: "90%",
          textAlign: "center",
        }}
      >
      

        {!error && (
          <div
            style={{
              width: "42px",
              height: "42px",
              border: "4px solid #e5e7eb",
              borderTop: "4px solid #2563eb",
              borderRadius: "50%",
              margin: "0 auto 20px",
              animation: "spin 1s linear infinite",
            }}
          />
        )}

        <div style={{ fontSize: "16px", color: "#1f2937", marginBottom: "10px" }}>
          {message}
        </div>

        {error && (
          <div style={{ color: "#b91c1c", fontSize: "14px", marginTop: "14px" }}>
            {error}
          </div>
        )}

        <style>
          {`
            @keyframes spin {
              from { transform: rotate(0deg); }
              to { transform: rotate(360deg); }
            }
          `}
        </style>
      </div>
    </div>
  );
}